module.exports = __webpack_public_path__ + "static/media/lightblades-in-context.7f1f1cff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lightblades/lightblades-in-context.jpg
// module id = 4227
// module chunks = 13